import React, { FC, useEffect, useState, useRef, useCallback } from "react"

/**
 * 显示室内地图
 * @param AMap
 * @param mapIns
 * @param geo
 * example: https://lbs.amap.com/api/javascript-api/example/overlayers/geojson/
 */

type PolygonProps = {
  visible: boolean
  map: any
  geo: any
  store: any
  activeProfileKey: string
}
const Polygon: FC<PolygonProps> = ({
  visible,
  map,
  geo,
  store,
  activeProfileKey,
}) => {
  const ref = useRef<any>()
  const clear = useCallback(() => {
    if (ref.current) {
      ref.current.setMap(null)
      ref.current = null
    }
  }, [ref])

  useEffect(() => {
    if (!visible) {
      clear()
    } else if (map && geo) {
      clear()
      const AMap = window.AMap
      var geojson = new AMap.GeoJSON({
        geoJSON: geo,
        // 还可以自定义getMarker和getPolyline
        getPolygon: function (feature: any, lnglats: any) {
          let prop = feature.properties._parentProperities
          // 计算面积
          let active = prop.key === activeProfileKey
          let color = active ? "red" : prop.color
          let strokeWeight = 1
          return new AMap.Polygon({
            path: lnglats,

            strokeWeight,
            strokeColor: color,
            strokeOpacity: active ? 0.3 : 1,
            fillColor: color,
            fillOpacity: 0.1,
            extData: prop,
            cursor: "pointer",
            // strokeStyle: active ? "solid" : "dashed",
          })
        },
      })
      geojson.setMap(map)
      geojson.on("click", (e) => {
        let park = e.target.getExtData()
        store.changeArea(park, true)
        console.log("e", park, e.lnglat)
      })
      ref.current = geojson
    }
    return () => {
      clear()
    }
  }, [map, geo, visible, clear, ref, store, activeProfileKey])
  return null
}
/**
 * 显示名称
 * @param AMap
 * @param mapIns
 * @param geo
 * example: https://lbs.amap.com/api/javascript-api/example/marker/labelsmarker-text
 * {"name":"张六庄镇","position":["113.280637","23.125178"],"zooms":[5,13],"zIndex":1,"opacity":1,"text":{"content":"广东","direction":"center","offset":[0,0],"zooms":[3,20],"style":{"fontSize":15,"fontWeight":"normal","fillColor":"#eee","strokeColor":"#c67805","strokeWidth":2}}}
 *
 */
type LabelProps = {
  visible: boolean
  map: any
  geo: any
  activeProfileKey: string
}
const Label: FC<LabelProps> = ({ visible, map, geo, activeProfileKey }) => {
  const ref = useRef<any>()
  const clear = useCallback(() => {
    if (ref.current) {
      ref.current.clear()
      ref.current = null
    }
  }, [ref])
  useEffect(() => {
    if (!visible) {
      clear()
    } else if (map && geo) {
      clear()
      const AMap = window.AMap
      var layer = new AMap.LabelsLayer({
        rejectMapMask: true,
        // 开启标注避让，默认为开启，v1.4.15 新增属性
        collision: true,
        // 开启标注淡入动画，默认为开启，v1.4.15 新增属性
        animation: true,
      })
      map.add(layer)
      geo.features.forEach((feature, i) => {
        let { properties: prop } = feature

        let labels = prop.labels || []
        let active = prop.key === activeProfileKey
        labels.forEach((label) => {
          let conf = {
            name: label.name,
            position: label.coord,
            zooms: [1, 20],
            opacity: 1,
            text: {
              content: label.name,
              direction: "center",
              offset: [0, 0],
              zooms: [1, 20],
              style: {
                fontSize: 12, // * Env.getScale(),
                fontWeight: "normal",
                fillColor: active ? "red" : "#ddd", //"#01FEF1",
              },
            },
          }
          var labelsMarker = new AMap.LabelMarker(conf)
          layer.add(labelsMarker)
        })
      })
      ref.current = layer
    }
    return () => {
      clear()
    }
  }, [map, geo, visible, clear, ref, activeProfileKey])
  return null
}

/**
 * LayerAreaGeo
 * @param param0
 */
const LayerAreaGeo: FC<any> = ({
  data,
  map,
  visible,
  store,
  activeProfileKey,
}) => {
  if (!data) {
    return null
  }

  return (
    <div>
      <Polygon
        visible={visible}
        map={map}
        geo={data}
        store={store}
        activeProfileKey={activeProfileKey}
      />
      <Label
        visible={visible}
        map={map}
        geo={data}
        activeProfileKey={activeProfileKey}
      />
    </div>
  )
}

export default LayerAreaGeo
